import { Component, Prop, h, Host, Element } from '@stencil/core';
import { Color } from '../../interface';
import { DropdownBoxType } from './dropdown-interface';
import { hasSlot } from '../../utils';

/**
 * @since 1.0
 * @status Stable
 *
 * @slot - Dropdown content.
 * @slot heading - Set heading html content.
 *
 * @part dropdown - Main checkbox container.
 * @part header - Dropdown header element.
 * @part content - Content container.
 */

/**
 * @deprecated Use o2-accordion component instead.
 */
@Component({
  tag: 'o2-dropdown',
  styleUrl: 'dropdown.scss',
  shadow: true,
})
export class O2Dropdown {
  private hasHeadingSlot: boolean;
  private hasIconSlot: boolean;

  private contentId: string = `o2-dropdown-${o2DropdownId}`;

  @Element() private el: HTMLO2DropdownElement;

  /**
   * Set type of dropdown box.
   */
  @Prop({ reflect: true }) type?: DropdownBoxType = 'compact';

  /**
   * Set main title.
   */
  @Prop() heading?: string;

  /**
   * Set right title.
   */
  @Prop() headingRight?: string;

  /**
   * By default, the dropdown is closed.
   */
  @Prop({ reflect: true, mutable: true }) open? = false;

  /**
   * If true, left border is visible.
   */
  @Prop() borderLeft?: boolean = false;

  /**
   * Set border color.
   * Possible values: `"primary"`, `"success"`, `"warning"`, `"danger"`.
   */
  @Prop() borderColor?: Color;

  /**
   * If true, dropdown is always closed and arrow is hidden
   */
  @Prop() disabled?: boolean = false;

  private onClickToggle = () => {
    if (!this.disabled) {
      this.open = !this.open;
    }
  };

  connectedCallback() {
    this.hasHeadingSlot = hasSlot(this.el, '[slot="heading"]');
    this.hasIconSlot = hasSlot(this.el, '[slot="icon"]');
  }

  render() {
    return (
      <Host>
        <div
          part="dropdown"
          class={`dropdown ${this.borderLeft ? 'dropdown--border-left' : ''} ${this.open ? 'dropdown--open' : ''} ${this.borderColor ? 'dropdown--border-' + this.borderColor : ''} dropdown--${this.type} ${
            this.disabled ? 'dropdown--disabled' : ''
          } `}
        >
          <button
            id={this.contentId}
            type="button"
            class="dropdown__header"
            onClick={this.onClickToggle}
            part="header"
            aria-expanded={this.open.toString()}
            aria-controls={`${this.contentId}-section`}
            disabled={this.disabled}
          >
            {this.heading && <span class="dropdown__heading">{this.heading}</span>}
            {this.hasHeadingSlot && <slot name="heading" />}
            {this.headingRight && <span class="dropdown__heading-right">{this.headingRight}</span>}

            {!this.disabled ? (
              <div class="dropdown__icon">{this.hasIconSlot ? <slot name="icon" /> :
                <o2-icon size={20} name="chevron-down" color="blue-action"></o2-icon>}</div>
            ) : (
              ''
            )}
          </button>
          <div id={`${this.contentId}-section`} role="region" class="dropdown__content" part="content"
               aria-labelledby={this.contentId} aria-hidden={(!this.open).toString()}>
            <slot></slot>
          </div>
        </div>
      </Host>
    );
  }
}

let o2DropdownId = 0;
